export default "__VITE_ASSET__paUmRy3bLCS9Viqg79ErlQ__"